export interface Vehicle {
  id: number;
  tenant_id: number;

  // Identification
  internal_number: string;
  license_plate: string | null;
  vin: string | null;

  // Vehicle data
  manufacturer: string;
  model: string;
  variant: string | null;

  // Category
  category: string;

  // Technical data
  first_registration: string | null;
  fuel_type: string | null;
  transmission: string | null;
  power_kw: number | null;
  power_hp: number | null;
  seats: number | null;
  doors: number | null;
  color: string | null;

  // Equipment
  equipment: string[];

  // Condition
  condition: string;
  current_mileage: number;

  // Insurance
  insurance_company: string | null;
  insurance_policy_number: string | null;
  insurance_expires_at: string | null;

  // TÜV/Service
  tuv_expires_at: string | null;
  next_service_at: string | null;
  next_service_km: number | null;
  tire_type: 'sommer' | 'winter' | 'allwetter' | null;

  // Prices (in cents)
  price_per_day_cents: number;
  price_per_week_cents: number | null;
  price_per_month_cents: number | null;
  price_per_km_cents: number;
  included_km_per_day: number;

  // Deposit (in cents)
  deposit_cents: number;

  // Images
  images: string[];
  thumbnail_url: string | null;

  // Status
  status: 'available' | 'rented' | 'maintenance' | 'inactive';
  is_active: boolean;

  // Notes
  notes: string | null;
  internal_notes: string | null;

  // Timestamps
  created_at: string;
  updated_at: string;
}

export interface VehicleCreate {
  internal_number: string;
  license_plate?: string;
  vin?: string;
  manufacturer: string;
  model: string;
  variant?: string;
  category: string;
  first_registration?: string;
  fuel_type?: string;
  transmission?: string;
  power_kw?: number;
  power_hp?: number;
  seats?: number;
  doors?: number;
  color?: string;
  equipment?: string[];
  condition?: string;
  current_mileage?: number;
  insurance_company?: string;
  insurance_policy_number?: string;
  insurance_expires_at?: string;
  tuv_expires_at?: string;
  next_service_at?: string;
  next_service_km?: number;
  tire_type?: 'sommer' | 'winter' | 'allwetter';
  price_per_day_cents: number;
  price_per_week_cents?: number;
  price_per_month_cents?: number;
  price_per_km_cents?: number;
  included_km_per_day?: number;
  deposit_cents?: number;
  images?: string[];
  thumbnail_url?: string;
  status?: 'available' | 'rented' | 'maintenance' | 'inactive';
  is_active?: boolean;
  notes?: string;
  internal_notes?: string;
}

export type VehicleUpdate = Partial<VehicleCreate>;

export interface VehicleListResponse {
  vehicles: Vehicle[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
}

// Helper function to format price from cents to EUR
export function formatPrice(cents: number): string {
  return (cents / 100).toFixed(2) + ' €';
}

// Helper function to parse EUR to cents
export function parsePrice(euroString: string): number {
  const cleaned = euroString.replace(/[€\s]/g, '').replace(',', '.');
  return Math.round(parseFloat(cleaned) * 100);
}
